<template>
	<div id="RegistrationForm">
		<form action="/action_page.php" class="w-100 d-flex flex-column align-items-baseline" id="registrationPublicForm">
			<div class="form-control-wrap my-1">
				<input type="text" class="form-control" id="name" :placeholder="translations.company_name + '*'" v-model="inputs.name" name="name">
			</div>
			<div class="form-control-wrap my-1">
				<select name="country" v-model="inputs.country" class="form-control country-select" id="">
					<option :value="null" selected disabled>{{ translations.country }}*</option>
					<option v-for="country in countries" :value="country">{{ country }}</option>
				</select>
			</div>
			<div class="form-control-wrap my-1">
				<input type="text" class="form-control" id="mesto" :placeholder="translations.city + '*'" v-model="inputs.city" name="mesto">
			</div>
			<div class="form-control-wrap my-1">
				<input type="text" class="form-control" id="adresa" :placeholder="translations.address + '*'" v-model="inputs.address" name="adresa">
			</div>
			<div class="form-control-wrap my-1">
				<input type="number" class="form-control" id="psc" :placeholder="translations.zip + '*'" v-model="inputs.zip" name="psc">
			</div>
			<div class="form-control-wrap my-1">
				<input type="number" class="form-control" id="phone" :placeholder="translations.phone + '*'" v-model="inputs.phone" name="phone">
			</div>
			<div class="form-control-wrap my-1">
				<input type="email" class="form-control" id="email" :placeholder="translations.email_form + '*'" v-model="inputs.email" name="email">
			</div>
			<div class="form-control-wrap my-1">
				<input type="text" class="form-control" id="web" :placeholder="translations.web + ' (format https://www.example.com) ' + '*'" v-model="inputs.web" name="web">
			</div>
			<div class="form-control-wrap my-1">
				<input type="number" class="form-control" id="latitude" :placeholder="translations.gps_lat + ' (format xx.xxxxxx) ' + '*'" v-model="inputs.gps_lat" name="gps_lat">
			</div>
			<div class="form-control-wrap my-1">
				<input type="number" class="form-control" id="longitude" :placeholder="translations.gps_lon+ ' (format xx.xxxxxx) ' + '*'" v-model="inputs.gps_lon" name="gps_lon">
			</div>
			<div class="mb-2 mt-1" style="overflow: hidden; min-width: 600px">
				<div @click.prevent="onCheck()" :style="[inputs.gdpr ? {'background-position': 'top center'} : {'background-position': 'bottom center'}]" style="margin-right:10px; float: left; width: 22px; height:22px; display: inline-block; background: transparent url('../images/checkbox.png') no-repeat bottom center"></div>
				<span style="float: left; cursor: default">{{ translations.agree_with_gdpr_part1 }} <a href="/preview-file/gdpr.pdf" class="aura-link" style="display: inline; text-transform: none; color: #0575E6;">{{ translations.agree_with_gdpr_part2 }}</a></span>
			</div>
		</form>

		<div class="alert alert-success mt-3" v-if="response.result && response.result !== null">
			{{ response.message }}
		</div>

		<div class="alert alert-danger mt-3" v-if="!response.result && response.result !== null">
			{{ response.message }}
		</div>

		<button  class="btn btn-default mt-3 g-recaptcha"
				 id="btn-confirm"
				 data-sitekey="6LdqIWMcAAAAAJxHWZZK5VWWwhktAzusocLwsJcY"
				 type="submit"
				 @click.prevent="showConfirmationModal"
		>{{ translations.confirm }}</button>

		<registration-form-modal :inputs="inputs" :translations="translations" v-on:submitted="setResponse" />
	</div>
</template>

<script>
import RegistrationFormModal from "./RegistrationFormModal";

export default {
	name: "RegistrationForm",
	props: ['countries', 'translations'],
	data() {
		return {
			inputs: {
				name: null,
				country: null,
				city: null,
				address: null,
				zip: null,
				phone: null,
				email: null,
				web: null,
				gps_lat: null,
				gps_lon: null,
				gdpr: null,
			},
			response: {
				result: null,
				message: null,
			},
		}
	},
	components: {
		RegistrationFormModal,
	},
	methods: {
		showConfirmationModal() {
			axios.post('/sidlo/registracia/validate', this.inputs).then((response) => {
				if (response.data.result === true) {
					$("#mi-modal").modal('show');
				} else {
					this.response = response.data;
				}
			});
		},
		setResponse(data) {
			this.response = data;

			if (data.result) {
				this.truncateInputsObject();
			}
		},
		truncateResponseObject() {
			this.response = {
				result: null,
				message: null,
			};
		},
		truncateInputsObject() {
			this.inputs = {
				name: null,
				country: null,
				city: null,
				address: null,
				zip: null,
				phone: null,
				email: null,
				web: null,
				gps_lat: null,
				gps_lon: null,
				gdpr: null,
			};
		},
		getLocaleString(object, locale) {
			return object[locale] ? object[locale] : object['sk'];
		},

		onCheck() {
			this.inputs.gdpr = !this.inputs.gdpr;
		}
	}
}
</script>

<style scoped>
	#RegistrationForm {
		width: 100%;
	}
</style>
